var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.isInit,
              expression: "!isInit"
            }
          ],
          staticClass: "rich-text"
        },
        [
          _c("h3", { staticClass: "edit-field-title" }, [
            _vm.field.name
              ? _c(
                  "div",
                  { staticClass: "label-item" },
                  [
                    _c("p", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.field.desc))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "light", placement: "bottom-start" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v("\n                    - name: "),
                            _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                            _c("br")
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "label-icon el-icon-info" })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "weixinaddress-input" },
            [
              _c("weixinCollectInput", {
                on: { "collect-res": _vm.collectResHandler },
                model: {
                  value: _vm.collection_address,
                  callback: function($$v) {
                    _vm.collection_address = $$v
                  },
                  expression: "collection_address"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("ueEditor", {
            ref: "ueEditorEle",
            attrs: { name: _vm.field.name || _vm.randomNum },
            on: {
              "content-change": _vm.contentChangeHandler,
              blur: _vm.contentChangeHandler,
              "init-complete": _vm.ueEditorInitHandler
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1de9f3df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1de9f3df","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/richTextForm.vue
// module id = 1213
// module chunks = 7